import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

import { cx } from '../../lib/cx';
import styles from './button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Роль кнопки на экране. `primary` — ink-заливка, единственная на экран:
   * две «главные» кнопки означают, что главной нет ни одной.
   */
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  /** Иконка перед текстом. Иконка без текста требует `aria-label` у самой кнопки. */
  icon?: ReactNode;
}

/**
 * Кнопка «Табло».
 *
 * `type` по умолчанию `button`, а не `submit`: у HTML это самый частый источник
 * случайной отправки формы — на экране печати такая отправка означает лишнюю
 * напечатанную этикетку.
 */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'secondary', size = 'md', fullWidth, icon, className, children, type, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      className={cx(
        styles.button,
        styles[variant],
        size !== 'md' ? styles[size] : undefined,
        fullWidth ? styles.fullWidth : undefined,
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
});
